interface IconProps {
  className?: string;
  filled?: boolean;
}

export function AlertCircleIcon({ className, filled }: IconProps) {
  if (filled) {
    return (
      <svg className={className} viewBox="0 0 24 24" fill="currentColor">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 6.75a.75.75 0 01.75.75v5.25a.75.75 0 01-1.5 0V7.5a.75.75 0 01.75-.75zm0 10.5a.938.938 0 100-1.875.938.938 0 000 1.875z"
        />
      </svg>
    );
  }
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12 7.5v5.25m0 3.75h.008v.008H12v-.008zm9-4.5a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
}
